import { queryOptions } from '@tanstack/react-query';
import type {
  ListUnreadNotificationsData,
  ListUnreadNotificationsResponse,
  UserNotificationGroup,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';

const getUnreadNotificationsUrl: ListUnreadNotificationsData['url'] =
  'notifications';

export interface GetUnreadNotificationsParams {
  group?: UserNotificationGroup;
  pageNumber?: number;
  pageSize?: number;
}

export const getUnreadNotificationsKey = (
  params: GetUnreadNotificationsParams = {},
) => ['notifications', 'unread', params] as const;

export const getUnreadNotificationsOptions = <
  T = ListUnreadNotificationsResponse,
>(
  params: GetUnreadNotificationsParams = {},
) =>
  queryOptions<ListUnreadNotificationsResponse, unknown, T>({
    queryKey: getUnreadNotificationsKey(params),
    queryFn: () =>
      PrivateApi.get(getUnreadNotificationsUrl, {
        searchParams: {
          group: params.group,
          pageNumber: params.pageNumber,
          pageSize: params.pageSize,
        },
      }).json<ListUnreadNotificationsResponse>(),
  });
